import { useMemo, useEffect } from 'react';
import idleTimeout from 'idle-timeout';

export const useSessionTimeout = (duration = 10000, onExpiry) => {
  const timer = useMemo(() => idleTimeout(
    () => {
      onExpiry();
      timer.destroy();
    }, {
      timeout: duration,
    },
  ), [duration, onExpiry]);


  useEffect(() => () => {
    timer.destroy();
  }, [timer]);

  return {
    activate() {
      timer.reset();
    },
    reset() {
      timer.destroy();
    },
  };
};
